module.exports = __webpack_public_path__ + "static/media/Octillery_gaussian2.f062c70a.png";